export default {
  setView(state, payload) {
    state.profitView = payload.value;
  },
  increaseTimer(state) {
    state.timer++;
  },
  resetTimer(state) {
    state.timer = 0;
  },
  setTimeUnits(state, payload) {
    state.timeUnits = payload.units;
  },
  setCurrency(state, payload) {
    state.selectedCurrency = payload.currency;
  },
  setGameCategory(state, payload) {
    state.gameCategory = payload.category;
  },
};
